.TouchTarget {
  position: absolute;
  left: 50%;
  top: 50%;
  width: max(100%, 44px);
  height: max(100%, 44px);
  transform: translate(-50%, -50%);
  @media (pointer: fine) {
    display: none;
  }
}
